export enum MessageType {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    ALARM = 'ALARM',
    UNRECOGNIZED = 'UNRECOGNIZED'
}
